// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aTBEhadqZVM94JZqzhH_{color:var(--content-primary-tertiary);align-items:center;gap:4px;height:24px;margin-top:30px;margin-left:20px;display:flex}.XIH03ONSIgshIROjRlBk{cursor:pointer;height:20px;color:var(--content-primary-tertiary);border-radius:4px;justify-content:center;align-items:center;gap:4px;padding:0 6px 0 4px;text-decoration:none;display:flex}.XIH03ONSIgshIROjRlBk span{line-height:15px}.XIH03ONSIgshIROjRlBk:hover{background:var(--background-neutral-subtle)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `aTBEhadqZVM94JZqzhH_`,
	"link": `XIH03ONSIgshIROjRlBk`
};
export default ___CSS_LOADER_EXPORT___;
